import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

// import logo from "../../assets/images/buffalo-logo.png";
// import logoLightPng from "../../assets/images/logo-light.png";
// import logoLightSvg from "../../assets/images/logo-light.svg";
// import logoDark from "../../assets/images/logo-dark.png";
import { useSelector } from 'react-redux';

const Sidebar = props => {
  const businessSettings = useSelector(state => state.businessSettings);
  const layout = useSelector(state => state.Layout);
  const { logo } = businessSettings;
  const { topbarTheme } = layout;

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className={`navbar-brand-box bg-${topbarTheme === "light" ? 'white' : 'sidebarDark'}`}>
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img className="" src={logo} alt="" height="16" />
            </span>
            <span className="logo-lg">
              <img className="" src={logo} alt="" height="40" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img className="" src={logo} alt="" height="16" />
            </span>
            <span className="logo-lg">
              <img className="" src={logo} alt="" height="40" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
